import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { ContractorNomenclaturePriceCreate, ContractorNomenclaturePriceDetail } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorNomenclatureDetail: builder.query<ContractorNomenclaturePriceDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorNomenclaturePrice/${data.id}/details`,
      }),
    }),
    changeContractorNomenclature: builder.mutation<void, ContractorNomenclaturePriceDetail>({
      query: (data) => ({
        url: `/v1/ContractorNomenclaturePrice/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createContractorNomenclature: builder.mutation<void, ContractorNomenclaturePriceCreate>({
      query: (data) => ({
        url: '/v1/ContractorNomenclaturePrice',
        method: 'POST',
        body: data,
      }),
    }),
    deleteContractorNomenclature: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorNomenclaturePrice/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeContractorNomenclatureMutation,
  useCreateContractorNomenclatureMutation,
  useDeleteContractorNomenclatureMutation,
  useGetContractorNomenclatureDetailQuery,
  useLazyGetContractorNomenclatureDetailQuery,
} = request;
